// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/6ad2f651/" + chunkId + "." + __webpack_require__.h() + ".v6ad2f651.js";
};